import { useState, useEffect } from 'react';
import { UserDataService, UserAuditLog } from '@/services/features/UserDataService';
import { useServiceWithAuth } from '../useServiceWithAuth';
import { useErrorHandler } from '../useErrorHandler';

export const useUserAuditLog = (userId: number | null) => {
  const [userAuditLogs, setUserAuditLogs] = useState<UserAuditLog[]>([]);
  const [auditLogsLoading, setAuditLogsLoading] = useState(false);
  const userDataService = useServiceWithAuth(UserDataService);
  const { handleError } = useErrorHandler();

  useEffect(() => {
    const fetchAuditLogs = async () => {
      if (!userId) {
        setUserAuditLogs([]);
        return;
      }

      setAuditLogsLoading(true);
      try {
        const result = await userDataService.getUserAuditLog(userId);
        setUserAuditLogs(result.logs);
      } catch (error) {
        handleError(error, 'Failed to fetch user audit logs');
        setUserAuditLogs([]);
      } finally {
        setAuditLogsLoading(false);
      }
    };

    fetchAuditLogs();
  }, [userId]);

  return {
    userAuditLogs,
    auditLogsLoading,
  };
};
